import { Helmet } from 'react-helmet-async';

/**
 * SEO komponenta pro správu meta tagů a strukturovaných dat
 * @param {Object} props - SEO props
 * @param {string} props.title - Titulek stránky
 * @param {string} props.description - Popis stránky
 * @param {string} props.keywords - Klíčová slova (volitelné)
 * @param {string} props.image - URL obrázku pro Open Graph (volitelné)
 * @param {string} props.url - Kanonická URL stránky (volitelné)
 * @param {string} props.type - Typ stránky (website, article, atd.) - default: "website"
 * @param {Object} props.structuredData - JSON-LD strukturovaná data (volitelné)
 */
export default function SEO({
  title = "digibezstresu - Digitální vzdělávání bez stresu",
  description = "Moderní vzdělávací platforma nabízející online a prezenční kurzy. Učte se bez stresu, digitálně a efektivně.",
  keywords = "vzdělávání, kurzy, online kurzy, prezenční kurzy, digitální vzdělávání, vzdělávací platforma",
  image = "/logo500x500_transparent.png",
  url = "",
  type = "website",
  structuredData = null
}) {
  // Základní URL webu (měli byste změnit na produkční URL)
  // Zajišťujeme, že canonical tagy vždy používají non-www verzi
  let siteUrl = process.env.REACT_APP_SITE_URL || "https://digibezstresu.cz";
  // Odstranění www z URL pro konzistentní canonical tagy
  siteUrl = siteUrl.replace(/^https?:\/\/www\./, 'https://');
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Základní meta tagy */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph meta tagy (Facebook, LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="cs_CZ" />
      <meta property="og:site_name" content="digibezstresu" />

      {/* Twitter Card meta tagy */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Další užitečné meta tagy */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="digibezstresu" />
      <meta name="language" content="Czech" />
      <meta name="revisit-after" content="7 days" />

      {/* Strukturovaná data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}

